export const tip = {
	title: "Configuração de gorjeta",
};
